import classNames from 'classnames'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'

const renderDefaultHint = (title, props) => <div {...props}>{title}</div>

const CodiDocumentMeta = ({
  style,
  title,
  className,
  description,
    document_no,
  Wrapper = 'div',
  renderHint = renderDefaultHint,
  ...props
}) => {
  const t = useTranslate()
  return (
    <Wrapper
      style={{
        minHeight: 32,
        padding: '6px 12px',
        ...(style || {}),
      }}
      className={classNames(
        'flex flex-col justify-center gap-1 border rounded-lg background cursor-pointer hover:shadow-out',
        className
      )}
      {...props}>
      {!_.every([title, description, document_no], _.isEmpty) && (
          <div className="flex flex-col gap-1">
              <span className="text-color-000 text-sm font-semibold leading-tight">
                  {title}
              </span>
              {document_no && (
                  <div className="font-medium text-xs text-color-200 italic">
                      <span className="font-light text-color-400">
                        {t('document no')}{' : '}
                      </span>
                      {document_no}
                  </div>
              )}
              {description && (
                  <span className="text-xs text-color-300 leading-tight italic">
                      {description}
                  </span>
              )}
          </div>
      )}
      {renderHint(`( ${t('click to change')} )`, {
        className: 'text-right italic text-2xs text-color-500',
      })}
    </Wrapper>
  )
}

export default CodiDocumentMeta
